<template>
    <div class="member-detail">
        <ul>
            <template v-for="(item, index) in categoryDetailList">
                <li
                    v-if="(isUnion && item.type === 3) || (!isUnion && item.type !== 3)"
                    :data-entrance="item.name"
                    :class="{
                        active: productIndex == index,
                        fake: item.type == 2 && productIndex != index,
                        fakeIsEmpty: item.stockStatus == 2 && item.type == 2,
                        union: item.type === 3 && item.jointImg,
                    }"
                    @click.stop="changeProductIndex(index, item)"
                    :key="item.id"
                    v-intersection
                    :data-log="JSON.stringify({ tj: skuShowDataLog(item), gio: skuShowGioDataLog(item) })"
                >
                    <!--  普通sku  -->
                    <template v-if="item.payment_cycle === 0">
                        <template v-if="isCY">
                            <div
                                class="list-tab__black"
                                :class="{ 'list-tab__coupon': item.coupon }"
                                v-if="item.corner_mark"
                            >
                                {{ item.corner_mark }}
                            </div>
                            <div class="cy-name">{{ item.spec_name ? item.spec_name : item.spec }}</div>
                            <div class="cy-office-price">官方价 ¥{{ item.unit_price_old }}</div>
                            <div v-if="isSC_CY" class="cy-tq-price">券后价 ¥{{ item.bestPrice }}</div>
                            <div v-else class="cy-tq-price">特权价 ¥{{ item.bestPrice }}</div>
                        </template>

                        <template v-else>
                            <div
                                class="list-tab__black"
                                :class="{ 'list-tab__coupon': item.coupon, 'list-tab__fake': item.type == 2 }"
                                v-if="item.corner_mark"
                            >
                                {{ item.corner_mark }}
                            </div>
                            <img v-if="item.jointImg" class="union-img" :src="item.jointImg" />
                            <div v-if="isUnion && item.jointImg" class="fs1 union">
                                {{ item.name }}
                            </div>
                            <div class="fs1" :class="{ time: isUnion && item.jointImg }">
                                {{ item.spec_name ? item.spec_name : item.spec }}
                            </div>
                            <div class="fs3">
                                ¥<span class="price">{{ item.bestPrice | formatPrice }}</span>
                            </div>

                            <div
                                class="fs2-wrap"
                                v-if="!isUnion || !item.jointImg"
                                :class="{ cashback: Number(item.rebateAmount) }"
                            >
                                <span class="fs2">¥{{ item.unit_price_old }}</span>
                            </div>

                            <div class="fs5">
                                <div v-if="Number(item.rebateAmount)" class="cashback-label">
                                    <div class="cashback-label-icon"></div>
                                    <div class="cashback-label-text">返现 ¥{{ item.rebateAmount }}</div>
                                </div>
                            </div>
                        </template>
                    </template>

                    <!-- 连续包月sku -->
                    <template v-else>
                        <div
                            class="list-tab__black"
                            :class="{ 'list-tab__coupon': item.coupon }"
                            v-if="item.corner_mark"
                        >
                            {{ item.corner_mark }}
                        </div>
                        <img v-if="item.jointImg" class="union-img" :src="item.jointImg" />
                        <div class="fs1">连续包月</div>
                        <div
                            v-if="item.price_type == 'first_month_price'"
                            :class="[
                                'price-wrap',
                                { 'price-wrap-padding': item.bestPrice && item.bestPrice.length > 4 },
                            ]"
                        >
                            <span class="price-wrap-word">首月</span>
                            <span class="price-wrap-symbol">¥</span>
                            <p>{{ parseFloat(item.bestPrice) }}</p>
                        </div>
                        <div class="price-wrap" v-else>
                            <span class="price-wrap-word">续费¥</span>
                            <p>{{ item.bestPrice | formatPrice }}</p>
                        </div>
                        <div class="fs2-wrap">
                            <span class="fs2">¥{{ item.unit_price_old | needFloatPrice }}</span>
                        </div>
                        <transition name="fade">
                            <div class="list-tips-wrap" v-if="showTips && productIndex == index">
                                <div class="list-tips">
                                    <p class="list-tips-text" v-if="item.price_type == 'first_month_price'">
                                        首月到期按每月{{
                                            parseFloat(item.other_month_price)
                                        }}元自动续费，可随时关闭。有疑问可看<span class="red" @click="linkToQue"
                                            >常见问题</span
                                        >
                                    </p>

                                    <p class="list-tips-text" v-else>
                                        每月自动续费，可随时关闭。有疑问可查看<span class="red" @click="linkToQue"
                                            >常见问题</span
                                        >
                                    </p>
                                </div>
                                <div class="list-tips-close" @click="closeTips"></div>
                                <i class="list-tips-triangle_white"></i>
                            </div>
                        </transition>
                    </template>
                </li>
            </template>
        </ul>
    </div>
</template>
<script>
import { flattenPrivilegeCategory } from '@/common/privilege/utils';

export default {
    name: 'MemberDetail',
    props: {
        categoryDetailList: {
            type: Array,
            default: () => [],
        },
        isCY: {
            type: Boolean,
            default: false,
        },
        isSC_CY: {
            type: Boolean,
            default: false,
        },
        isSourceChannel: {
            type: Boolean,
            default: false,
        },
        productIndex: {
            type: Number,
            default: -1,
        },
        showTips: {
            type: Boolean,
            default: false,
        },
        isUnion: {
            type: Boolean,
            default: false,
        },
        pageInfo: {
            type: Object,
            default: () => {},
        },
    },
    methods: {
        changeProductIndex(index, item) {
            this.$emit('select', index, item);
        },
        skuShowDataLog(sku) {
            return JSON.stringify({
                obj_id: 'goods',
                obj_type: 'recharge_detail',
                business_type: 'recharge',
                goods_id: sku.id,
                // ...this.tjData,
                ...flattenPrivilegeCategory(sku.privilegeCategory),
                cat_id: this.id,
            });
        },
        skuShowGioDataLog(sku) {
            return JSON.stringify({
                productName_var: this.pageInfo.product.name,
                productSkuName_var: sku.name,
                productSkuid_var: sku.id + '',
                productCategory_var: sku.category,
            });
        },
        linkToQue() {
            // location.href = `${location.origin}/new/tqcz/rule/index.html`;
            location.href = 'https://m.black-unique.com/slime/pages/600/index.html';
        },
        closeTips(event) {
            this.$emit('close-tips');
            event.stopPropagation();
        },
    },
    filters: {
        formatPrice(v) {
            return parseFloat(Number(v).toFixed(2));
        },
        needFloatPrice(v) {
            return Number(v).toFixed(2);
        },
    },
};
</script>
<style lang="scss" scoped>
@mixin border-1px($color: #e6e6e6, $borderRadius: 100px) {
    position: relative;
    border-width: 0;
    &:after {
        content: ' ';
        width: 200%;
        height: 200%;
        position: absolute;
        top: 0;
        left: 0;
        border: 1px solid $color;
        -webkit-transform: scale(0.5);
        transform: scale(0.5);
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
        box-sizing: border-box;
        border-radius: $borderRadius;
    }
}

.member-detail {
    margin: 0.24rem 0.24rem 0.08rem;
    ul {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;

        li {
            position: relative;
            display: flex;
            flex-flow: column;
            align-items: center;
            width: 2.06rem;
            margin-right: 0.18rem;
            margin-bottom: 0.16rem;
            height: 2.2rem;
            // padding: .25rem .24rem;
            font-size: 0.28rem;
            font-weight: bold;
            text-align: center;
            // color: #6c3d05;
            @include border-1px(#e6e6e6, 0.16rem);
            box-sizing: border-box;

            &:nth-child(3n + 3) {
                margin-right: 0px;
            }

            &.union {
                height: 2.88rem;
            }

            &.active {
                background: linear-gradient(180deg, rgba(255, 226, 190, 0.08) 0%, rgba(255, 193, 155, 0.28) 100%);
                // @include border-1px(#fe8b22, 0.16rem);
                position: relative;
                border: 0.04rem solid #ee9f5c;
                border-radius: 0.08rem;

                &::before {
                    content: '';
                    display: block;
                    width: 0.44rem;
                    height: 0.44rem;
                    background: center / 100% 100% url(../../../images/icon-corner.png);
                    position: absolute;
                    right: -0.02rem;
                    bottom: -0.02rem;
                    border-radius: 0 0 0.08rem 0;
                }

                .fs1 {
                    margin-top: 0.44rem;
                    color: #ff521f;
                }

                .fs2-wrap {
                    .fs2 {
                        font-weight: 400;
                        color: #ffbca7;
                        &::after {
                            background: #ffbca7;
                        }
                    }
                }

                .fs3 {
                    font-family: FinancialNumber;
                    font-weight: 400;
                    color: #ff521f;

                    &-coupon {
                        color: #ff521f;
                    }
                }
                .cashback-label {
                    background: #ffe8da;
                }
                .list-tab__black {
                    top: -0.04rem;
                    left: -0.04rem;
                }
                &:after {
                    border-color: transparent;
                }
            }

            &.fakeIsEmpty {
                opacity: 0.3;
                &::before {
                    content: '';
                    display: block;
                    width: 0.96rem;
                    height: 0.96rem;
                    margin-top: 0.62rem;
                    background: center / 100% 100% url(../../../images/fake-sku-empty-V2.png);
                    position: absolute;
                }
            }

            .union-img {
                width: 1.72rem;
                height: 0.72rem;
                margin-top: 0.36rem;
            }
            .fs1 {
                display: block;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                width: 2rem;
                margin-top: 0.48rem;
                font-size: 0.24rem;
                color: #333333;
                font-weight: 400;
                &.union {
                    margin-top: 0.16rem;
                }
                &.time {
                    font-weight: 400;
                    margin-top: 0.08rem;
                }
            }
            .fs2-wrap {
                display: inline-block;
                line-height: 0.28rem;
                white-space: nowrap;
                margin-top: 0.08rem;
                &.cashback {
                    margin-top: -0.14rem;
                }
            }
            .fs2 {
                display: inline-block;
                position: relative;
                font-size: 0.28rem;
                color: #cccccc;
                margin-top: 0.08rem;
                font-weight: 400;

                &:after {
                    position: absolute;
                    content: '';
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                    width: 100%;
                    height: 1px;
                    background: #cccccc;
                }
            }
            .fs2-cycle {
                display: inline-block;
                position: relative;
                font-size: 0.2rem;
                font-weight: 300;

                &:after {
                    position: absolute;
                    content: '';
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                    width: 100%;
                    height: 1px;
                    background: linear-gradient(#6c3d05 40%, rgba(255, 255, 255, 0));
                }
            }
            .fs3 {
                display: inline-block;
                white-space: nowrap;
                border-radius: 0.2rem;
                padding: 0 0.16rem;
                height: 0.6rem;
                line-height: 0.6rem;
                // color: #6c3d05;
                color: #333;
                font-size: 0.28rem;
                font-family: FinancialNumber;
                font-weight: 400;
                margin-top: 0.08rem;
                .price {
                    margin-left: 0.04rem;
                    font-size: 0.48rem;
                    font-weight: 500;
                }

                &__fake {
                    color: #ff3838;
                }
            }
            .fs3-coupon {
                display: inline-block;
                white-space: nowrap;
                border-radius: 0.2rem;
                margin-top: 0.8rem;
                padding: 0 0.16rem;
                height: 0.4rem;
                height: 0.4rem;
                line-height: 0.4rem;
                // color: #6c3d05;
                color: #333;
                font-size: 0.28rem;

                .price {
                    font-size: 0.36rem;
                }
            }
            .fs4 {
                width: 100%;
                height: 0.38rem;
                background: rgba(248, 227, 192, 1);
                opacity: 0.5;
                position: absolute;
                bottom: 0;
                display: flex;
                justify-content: center;
                align-items: center;

                .fs4-text {
                    font-size: 0.22rem;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: rgba(127, 71, 6, 1);
                }
            }
            .fs5 {
                position: absolute;
                left: 0;
                bottom: 0;
                width: 100%;
                height: 0.4rem;
            }
            .product--type_1 {
                position: absolute;
                top: 0;
                left: 0;
                display: inline-block;
                background: url('../../../images/order_list-type_1.png') no-repeat center/100%;
                width: 1.07rem;
                height: 0.3rem;
            }
            .product--type_2 {
                position: absolute;
                top: 0;
                left: 0;
                display: inline-block;
                background: url('../../../images/order_list-type_2.png') no-repeat center/100%;
                width: 0.86rem;
                height: 0.3rem;
            }
            .price-wrap {
                display: flex;
                align-items: baseline;
                height: 0.64rem;
                box-sizing: border-box;
                line-height: 0.6rem;
                border-radius: 0.08rem;
                margin-top: 0.08rem;
                padding: 0 0.1rem;
                background: #ff4b21;
                color: #fff;
                font-size: 0.48rem;
                p {
                    position: relative;
                    top: 0.02rem;
                    font-family: FinancialNumber;
                    font-weight: 500;
                }
                .price-wrap-symbol {
                    font-size: 0.28rem;
                    font-weight: 400;
                }
                .price-wrap-word {
                    font-size: 0.28rem;
                    font-weight: 600;
                    white-space: nowrap;
                }
            }
            .price-wrap-padding {
                padding: 0 0.05rem;
            }
            .list-tips-wrap {
                position: absolute;
                box-sizing: border-box;
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 5.3rem;
                left: -0.04rem;
                top: -1.42rem;
                padding: 0.24rem;
                box-shadow: 0rem 0.14rem 0.28rem 0rem rgba(0, 0, 0, 0.13);
                background: #fff;
                border-radius: 0.16rem;
                border: 0.01rem solid #e6e6e6;
                z-index: 100;

                .list-tips-triangle {
                    position: absolute;
                    width: 0;
                    height: 0;
                    top: -0.08rem;
                    left: 0.96rem;
                    border-width: 0.1rem;
                    border-style: solid;
                    border-color: #fff #fff transparent transparent;
                    background: #fff;
                    box-shadow: #f7e7ba 0.03rem 0.03rem 0.1rem 0;
                    transform: rotate(45deg);
                    z-index: -1;
                }

                .list-tips-triangle_white {
                    position: absolute;
                    width: 0.28rem;
                    height: 0.12rem;
                    bottom: -0.08rem;
                    left: 0.86rem;
                    transform: rotate(180deg);
                    background: url('../../../images/icon-triangle.png') no-repeat center/100%;
                }

                .list-tips-close {
                    width: 0.4rem;
                    height: 0.32rem;
                    margin-left: 0.16rem;
                    background: url('../../../images/icon-close-V2.png') no-repeat center/100%;
                }
            }
            .list-tips {
                font-size: 0.24rem;
                color: #666666;
                z-index: 2;
                text-align: left;

                .list-tips-text {
                    font-weight: normal;

                    .red {
                        color: #000;
                        font-weight: 500;
                    }
                }

                &::after {
                    // content: '';
                    position: absolute;
                    width: 0;
                    height: 0;
                    position: absolute;
                    bottom: -0.1rem;
                    border-width: 0.1rem;
                    border-style: solid;
                    border-color: #fff #fff transparent transparent;
                    background: #fff;
                    box-shadow: #f7e7ba 0 0 0.1rem 0;
                    transform: rotate(45deg);
                    z-index: -1;
                    // position: absolute;
                    // display: inline-block;
                    // top: 380px;
                    // left: 300px;
                    // width: 0;
                    // height: 0px;
                    // content: '';
                    // border-style: solid;
                    // border-width: 20px;
                    // border-color: #fff #fff transparent transparent;
                    // transform: rotate(135deg);
                    // box-shadow: 2px -2px 2px #ccc;
                }
            }
            .list-tab__black,
            .list-tab {
                position: absolute;
                left: 0;
                top: 0;
                padding: 0.04rem 0.12rem;
                // background: linear-gradient(to right, #FF8F1D 0%,#FF661C 100%);
                // border-radius: .08rem 0 .1rem 0;
                line-height: 0.28rem;
                display: flex;
                align-items: center;

                background-image: linear-gradient(269deg, #ff8f1d 0%, #ff661c 100%);
                border-radius: 0.08rem 0.08rem 0.08rem 0rem;
                color: #fff;
                font-size: 0.2rem;
                z-index: 2;

                .list-tab-bg {
                    position: absolute;
                    content: '';
                    left: 0;
                    top: 0;
                    height: 0.3rem;
                    display: inline-block;
                    opacity: 0.7;
                    background-image: linear-gradient(269deg, #ff8f1d 0%, #ff661c 100%);
                    border-radius: 8px 0 10px 0;
                }

                .list-tab-text {
                    position: relative;
                    color: #fff;
                    z-index: 2;
                    font-weight: normal;

                    // &::after {
                    //     position: absolute;
                    //     content: '';
                    //     left: 0;
                    //     top: 0;
                    //     height: .3rem;
                    //     padding-right: .06rem;
                    //     background: linear-gradient(to right, #FF8F1D 0%,#FF661C 100%);
                    //     color: #fff;
                    //     opacity: .7;
                    //     width: 100%;
                    //     border-radius: .08rem 0 .1rem 0;
                    //     z-index: -1;
                    // }
                }
            }
            .list-tab__black {
                background: linear-gradient(119deg, #4d4d4d 0%, #1b1b1b 100%);
                color: #ffd4af;
                font-weight: 400;
                max-width: 1.82rem;
                display: block;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
            }

            .list-tab__coupon {
                background-image: linear-gradient(269deg, #ff8f1d 0%, #ff661c 100%);
            }
        }
    }
}
</style>
